import { render } from "./EngineeringCopilot.vue?vue&type=template&id=c3215f1a&scoped=true"
import script from "./EngineeringCopilot.vue?vue&type=script&lang=js"
export * from "./EngineeringCopilot.vue?vue&type=script&lang=js"

import "./EngineeringCopilot.vue?vue&type=style&index=0&id=c3215f1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3215f1a"]])

export default __exports__